<template>
  <el-dialog title="选择结佣代理" width="50%" :visible="value" modal-append-to-body append-to-body class="partial"
    @close="onCancel">
    <el-form inline :model="searchForm">
      <el-form-item label="ID" prop="id">
        <el-input v-model.trim="searchForm.id" :max-length="200" placeholder="请输入ID" />
      </el-form-item>
      <el-form-item label="代理昵称">
        <el-input v-model.trim="searchForm.nickname" :max-length="200" placeholder="请输入代理昵称" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onFormSearch">查询</el-button>
        <el-button @click="onFormReset">重置</el-button>
      </el-form-item>
    </el-form>

    <div v-if="table.dataSource && table.dataSource.length" class="partial-toolbar">
      <el-checkbox v-model="checkedAll" :disabled="!filterTableList.length" @change="onCheckedAll">全选所有<span
          class="partial-tip__red">（列表仅显示有达人关联的代理）</span></el-checkbox>
    </div>

    <el-table ref="table" v-loading="table.loading" :data="table.dataSource" border lazy row-key="userUUID" height="250"
      @selection-change="onSelectionChange">
      <el-table-column type="selection" width="55" :reserve-selection="true" />
      <el-table-column prop="id" label="ID" width="180" />
      <el-table-column prop="nickname" label="代理昵称" />
    </el-table>

    <!-- 分页-->
    <el-pagination v-if="table.total" class="table-pagination" @size-change="onSizeChange"
      @current-change="onCurrentChange" :current-page.sync="pagination.pageNo" :page-sizes="[10, 20, 30, 40]"
      :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="table.total" />
    <span slot="footer" class="partial-footer">
      <el-button @click="onCancel">取消</el-button>
      <el-button type="primary" @click="onSure">确认</el-button>
    </span>
  </el-dialog>
</template>
<script>
import pagination from '@/components/Pagination'
import douYin from "@/javaApi/douyin";
const DouYinModel = new douYin();

const searchParams = {
  id: '', // ID
  nickname: '' // 代理名称
}
export default {
  components: {
    pagination // 分页
  },
  props: {
    value: {
      // 是否显示弹框
      type: Boolean,
      default: false
    },
    userUUID: {
      // 已选中的
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      multipleSelection: [], // 表格选中
      checkedAll: false, // 全选所有
      table: {
        dataSource: [], // 表格数据
        total: 0, // 总数
        loading: false // 表格加载loading
      },
      searchForm: Object.assign({}, searchParams), // 搜索数据
      pagination: {
        // 分页
        pageSize: 10, // 表格分页页数
        pageNo: 1 // 表格当前页数
      },
      filterTableList: [], // 过滤的表格
      agentList: [] // 代理列表
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: async function (val, oldVal) {
        if (val) {
          await this.freshList()
          this.setSelectionChange()
        }
      }
    }
  },
  methods: {
    // 取消
    onCancel() {
      this.$emit('close', false)
    },
    // 确定
    onSure() {
      if (this.multipleSelection && this.multipleSelection.length) {
        this.$emit('selectPartial', this.multipleSelection)
        this.onCancel()
      } else {
        this.$message.error('请至少选择一个代理')
      }
    },
    // 搜索查询
    onFormSearch() {
      this.pagination.pageNo = 1
      this.freshTable()
      const multipleIds = this.multipleSelection.map((item) => item.userUUID)
      const filterIds = this.filterTableList.map((item) => item.userUUID)
      // 选中的是否包含过滤出来的
      const diffList = multipleIds.filter(
        (item) => filterIds.indexOf(item) > -1
      )
      if (this.filterTableList && this.filterTableList) {
        this.checkedAll = diffList.length === filterIds.length
      } else {
        this.checkedAll = false
      }
    },
    // 搜索重置
    onFormReset() {
      this.searchForm = Object.assign({}, searchParams)
      this.pagination.pageNo = 1
      this.freshTable()
      this.onCheckedAll(false)
    },
    // 分页数据变化
    onSizeChange(val) {
      this.pagination.pageSize = val;
      this.freshTable();
    },
    // 分页跳转
    onCurrentChange() {
      this.freshTable();
    },
    // 全选所有
    async onCheckedAll(value) {
      await this.$nextTick()
      this.filterTableList.forEach(async (item) => {
        this.$refs.table.toggleRowSelection(item, value)
      })
    },
    // 设置表格选中
    async setSelectionChange() {
      this.$refs.table && this.$refs.table.clearSelection()
      if (this.userUUID && this.userUUID.length) {
        const ids = this.userUUID.map((item) => item.userUUID)
        this.agentList.forEach(async (item) => {
          await this.$nextTick()
          if (ids.includes(item.userUUID)) {
            this.$refs.table.toggleRowSelection(item, true)
          }
        })
      }
    },
    // 表格选择
    onSelectionChange(arr) {
      this.multipleSelection = arr

      // 有查询条件的时候
      if (
        this.filterTableList &&
        this.filterTableList.length &&
        this.filterTableList.length !== this.agentList.length
      ) {
        this.checkedAll = arr.length === this.filterTableList.length
      } else {
        this.checkedAll = arr.length === this.agentList.length
      }
    },
    // 计算表格数据
    freshTable() {
      this.table.loading = true
      let list = [...this.agentList]
      list = list
        .filter((item) => item.id && item.id.indexOf(this.searchForm.id) > -1)
        .filter(
          (item) =>
            item.nickname &&
            item.nickname.indexOf(this.searchForm.nickname) > -1
        )
      this.filterTableList = list

      this.table.dataSource = list.slice(
        (this.pagination.pageNo - 1) * this.pagination.pageSize,
        this.pagination.pageNo * this.pagination.pageSize
      )
      this.table.total = list.length
      this.table.loading = false
    },
    // 请求表格
    async freshList() {
      this.table.loading = true
      const data = await DouYinModel.getAgentAllListKs().finally(() => {
        this.table.loading = false
      })

      if (data.data.code === 200) {
        this.agentList = data.data.data.map((item) => ({
          ...item,
          id: item.id.toString()
        }))
        this.freshTable()
      } else {
        this.$message.error(data.data.message || data.data.info)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.partial {
  &-toolbar {
    padding: 0 10px;
    margin-bottom: 20px;
  }

  &-tip {
    color: #999;

    &__red {
      color: red;
    }
  }

  &-ratio {
    width: 20%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/kuaishou/userData/PartialAgency.vue